<template>
  <span class="preview">
    <i
      class="preview-icon icon-prepend fa"
      v-if="prependicon"
      :class="prependicon.startsWith('fa-') ? prependicon : ''"
    >{{prependicon.startsWith('fa-') ? '' : prependicon}}</i>
    <span
      class="preview-text text-middle"
      :class="{'text-bold' : bold, 'appendicon-text-right': appendicon, 'prependicon-text-left': prependicon, 'both-side': appendicon && prependicon}"
      :id="model.$form.generateId ? model.$pathId : undefined"
      :data-path="model.$form.testPath ? model.$path : undefined"
    >
      <slot>{{value}}</slot>
    </span>
    <i
      class="preview-icon icon-append fa"
      v-if="appendicon"
      :class="appendicon.startsWith('fa-') ? appendicon : ''"
    >{{appendicon.startsWith('fa-') ? '' : appendicon}}</i>
    <br v-if="showError && model.$error" />
    <w-error v-if="showError" :model="model" class="error-msg"></w-error>
  </span>
</template>

<script>
import WError from './error.vue';
export default {
  name: 'w-preview',
  components: {WError},
  props: {
    model: Object,
    bold: Boolean,
    values: Array,
    valueKey: {type: String, default: 'value'},
    valueText: {type: String, default: 'text'},
    appendicon: {
      type: String,
      default: ''
    },
    prependicon: {
      type: String,
      default: ''
    },
    default: {
      type: [String, Number],
      default: ''
    },
    showError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    value: {
      get() {
        if (!this.model) {
          return '';
        }
        if (!this.values) {
          if (this.model.$value.length === 0 && this.default.length > 0) {
            return this.default;
          }
          return this.model.$value;
        }

        const key = this.valueKey || 'value';
        const textKey = this.valueText || 'text';
        const value = this.values.find(item => {
          return item[key] === this.model.$value;
        });
        if (value === undefined) {
          return '';
        }
        return value[textKey];
      }
    }
  }
};
</script>
<style scoped>
td span.preview span.preview-text,
th span.preview span.preview-text {
  vertical-align: middle !important;
}
span.preview,
span.preview div.error-msg {
  display: inline-block;
}
span.preview {
  vertical-align: top;
}
td > span.preview div.error-msg {
  display: block;
}
td > span.preview {
  min-height: 32px;
  display: block;
}
.preview-icon {
  position: relative !important;
}
td span.preview-text {
  display: inline-block;
  position: relative !important;
  top: 4px;
}
.appendicon-text-right {
  padding-right: 10px;
}
.prependicon-text-left {
  padding-left: 12px;
}
.both-side {
  width: Calc(100% - (2 * 26px) - 12px - 10px);
}
</style>


